import React from 'react'
import styled from 'styled-components'
import { path } from 'ramda'
import { EmailIcon, Theme, Mailto } from '@pga/pga-component-library'
import { withAuthProvider } from '../../../lib/auth'
import { Title } from '../../common/styled'
import SocialInfo from './SocialInfo'
import theme from '../../Layout/theme'

export const EmailAndSocialWrapped = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  @media screen and (max-width: 767.98px) {
    align-items: flex-start;
  }
`

const EmailIconStyled = styled(EmailIcon)`
  padding: 0 10px 0 0;
  svg path {
    stroke: ${Theme.colors.greyBlue}
  }
  cursor: auto;
`

const EmailWrapped = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom:10px;
  a {
    color: ${Theme.colors.lightBlue};
  }
`

const hasEmail = data => data.publicEmail || data.primaryEmail
const hasViewEmailPublic = path(['viewingPermissions', 'viewEmailPublic'])

export const EmailWrapper = ({ data }) => (
  <EmailWrapped>
    <EmailIconStyled />
    <Title color={theme.colors.lightBlue} fontSize='14' pt='0' pl='0'>
      <Mailto emailAddress={data.publicEmail || data.primaryEmail} />
    </Title>
  </EmailWrapped>
)

export const EmailAndSocial = ({ data, isLoggedIn }) => (
  <EmailAndSocialWrapped>
    {
      hasEmail(data)
        ? isLoggedIn
          ? <EmailWrapper data={data} />
          : hasViewEmailPublic(data) && <EmailWrapper data={data} />
        : null
    }
    {data.social && <SocialInfo social={data.social} />}
  </EmailAndSocialWrapped>
)

export default withAuthProvider(EmailAndSocial)
